import { render, staticRenderFns } from "./SharedGene.vue?vue&type=template&id=bc6f1618&"
import script from "./SharedGene.vue?vue&type=script&lang=js&"
export * from "./SharedGene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports